import { HttpInterceptorFn } from '@angular/common/http';
import { LocalStorageService } from '../services/localStorage/local-storage.service';
import { inject } from '@angular/core';
import { ToastService } from 'src/app/shared/services/toast.service';
import { jwtDecode } from 'jwt-decode';
import { catchError, throwError } from 'rxjs';


export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const localStorageService = inject(LocalStorageService);
  const toastr = inject(ToastService);
  const token = localStorageService.getAuthToken();

  const isTokenxEpired = (token: any) => {
    console.log('isTokenxEpired', token)
    try {
      const decodedToken: any = jwtDecode(token);
const expirationDate = decodedToken.exp * 1000;
console.log('Token expires at:', new Date(expirationDate), 'Now:', new Date());
return new Date().getTime() > expirationDate;
    } catch (error) {
      console.error('Failed to decode token:', error);
      return true;
    }
  }

 if (token && isTokenxEpired(token)) {
  console.log('🔴 LOGOUT TRIGGERED BY REQUEST:', req.url);
  toastr.errorToast('Session Expired');
  localStorageService.logout();
  return throwError(() => new Error('Token expired'));
}

  // return next(req);

  // Forward the request and handle response errors
  return next(req).pipe(
    catchError((error) => {
      console.error('HTTP error intercepted:', error);

      // Optionally handle specific status codes
      if (error.status === 401) {
        toastr.errorToast('Unauthorized. Please login again.');
        localStorageService.logout();
      } else if (error.status === 403) {
        toastr.errorToast(error?.error?.message || 'Access Denied.');
      } else if (error.status >= 500) {
        toastr.errorToast('Server error. Please try again later.');
      } else {
        console.log('error', error)
        toastr.errorToast(error?.error?.message || 'Something went wrong.');
      }
      return throwError(() => error);
    })
  );
};
